import { render, staticRenderFns } from "./CalendarAsideRestrictionsTest.vue?vue&type=template&id=21a56159&scoped=true&"
import script from "./CalendarAsideRestrictionsTest.vue?vue&type=script&lang=js&"
export * from "./CalendarAsideRestrictionsTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a56159",
  null
  
)

export default component.exports